import { createContext, use, type ReactNode } from 'react';

import type { Locale } from '../ports/i18n';
import type { PluginHost } from './plugin-runtime/host';

const HostContext = createContext<PluginHost | null>(null);
const LocaleContext = createContext<Locale>('ko');

export function PluginHostProvider({ host, locale, children }: { host: PluginHost; locale: Locale; children: ReactNode }) {
  return (
    <HostContext value={host}>
      <LocaleContext value={locale}>{children}</LocaleContext>
    </HostContext>
  );
}

export function usePluginHost(): PluginHost {
  const host = use(HostContext);
  if (!host) throw new Error('PluginHostProvider 밖에서 usePluginHost 호출');
  return host;
}

export function useLocale(): Locale {
  return use(LocaleContext);
}
